import LazyImg from 'App/Components/LazyImg';

import advantageBox from '../../../../../../assets/hero_advantage-box.svg';
import polyglot from '../../../../../../localization';
import './styles.scss';

/**
 * LightningHeroAdvantage renders a single advantage card: illustration,
 * decorative box, and localized description.
 *
 * @param {string} lang — Language key for the shared box background alt.
 * @param {string} src — Image source URL for the advantage icon.
 * @param {string} alt — Alt text for the advantage icon image.
 * @param {string} description — Localized text displayed on the card.
 */
export const LightningHeroAdvantage = ({ lang, src, alt, description }) => (
    <div className='lightning-hero-advantage'>
        <div className='lightning-hero-advantage__wrapper'>
            <LazyImg
                width={182}
                height={165}
                alt={alt}
                src={src}
                className='lightning-hero-advantage__icon'
            />

            <p className='lightning-hero-advantage__text'>{description}</p>
        </div>

        <LazyImg
            src={advantageBox}
            alt={polyglot.t(`${lang}.hero.alt.whiteBack`)}
            className='lightning-hero-advantage__card'
        />
    </div>
);
